module.exports = __webpack_public_path__ + "img/dzis.46db9822.png";